<p-dialog
  [(visible)]="visible"
  [style]="{ width: '90vw', height: '90vh' }"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onDialogHide()"
>
  <ng-template pTemplate="closeicon">
    <span class="closeicon pi pi-times"></span>
  </ng-template>
  <ng-template pTemplate="header">
    <div class="w-full flex justify-center">
      <p-steps
        [model]="items"
        [readonly]="true"
        [activeIndex]="activeTabIndex"
        [styleClass]="'completed-' + activeTabIndex"
      />
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <form id="addForm" class="h-full" [formGroup]="formGroup" novalidate>
      @if (getTabContent() === 'search') {
        <p-panel class="h-full">
          <div class="grid grid-cols-12 h-full w-full gap-2 items-center">
            <div class="col-span-12">
              <p-iftalabel>
                <input
                  type="text"
                  class="w-full"
                  pInputText
                  [(ngModel)]="searchTerm"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="{{
                    'animalAdd.general.search.placeholderExistingAnimal'
                      | transloco
                  }}"
                  spellcheck="false"
                  autocomplete="off"
                  (input)="onSearch()"
                  id="searchTerm"
                />
                <label for="searchTerm">
                  {{ 'animalAdd.search.headline' | transloco }}
                </label>
              </p-iftalabel>
            </div>
            @if (animalSearchResult.length > 0) {
              <div class="col-span-12 overflow-auto">
                <p-table
                  [value]="animalSearchResult"
                  [paginator]="animalSearchResult.length > 10"
                  [rows]="10"
                  class="p-mt-4"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th></th>
                      <th>
                        {{ 'animalAdd.general.basicData.name' | transloco }}
                      </th>
                      <th>
                        {{ 'animalAdd.general.basicData.type' | transloco }}
                      </th>
                      <th>
                        {{
                          'animalAdd.general.basicData.bookNumber' | transloco
                        }}
                      </th>
                      <th>
                        {{
                          'animalAdd.general.numbers.transponderNumber'
                            | transloco
                        }}
                      </th>
                      <th></th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-animal>
                    <tr>
                      <td class="relative">
                        <app-animal-image-container
                          [animal]="animal"
                          [preview]="true"
                        ></app-animal-image-container>
                      </td>
                      <td>{{ animal.name }}</td>
                      <td>{{ animal.type }}</td>
                      <td>{{ animal.bookNumber }}</td>
                      <td>
                        {{
                          animal.transponderNumber?.[0] ||
                            animal.transponderNumber
                        }}
                      </td>
                      @if (!animal.inStock) {
                        <td class="flex flex-row-reverse">
                          <p-button
                            label="{{
                              'animalAdd.general.foundAnimal.openFoundAnimal'
                                | transloco
                            }}"
                            icon="pi pi-external-link"
                            (click)="openFoundAnimal(animal)"
                          ></p-button>
                        </td>
                        <td>
                          <p-button
                            label="{{
                              'animalAdd.general.resumption.headline' | transloco
                            }}"
                            icon="pi pi-external-link"
                            (click)="resumeAnimalStep(animal)"
                          ></p-button>
                        </td>
                      }
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }
            <div class="col-span-12 flex justify-center">
              <p-button
                (click)="addNewAnimalStep()"
                icon="pi pi-plus"
                label="{{
                  'animalAdd.general.basicData.addNewAnimal' | transloco
                }}"
              />
            </div>
          </div>
        </p-panel>
      }
      @if (getTabContent() === 'category') {
        <p-panel class="flex flex-col justify-center items-center h-full p-5">
          <ng-template #header>
            <h2 class="w-full text-center">
              {{ 'animalAdd.general.basicData.chooseCategory' | transloco }}
            </h2>
          </ng-template>
          <div class="flex h-full items-center justify-center">
            <div
              class="flex flex-col items-center justify-center flex-wrap card-container"
            >
              <div class="flex flex-wrap mt-5 gap-2">
                @for (filter of categoryFilters; track filter) {
                  <p-button
                    [styleClass]="
                      'w-24 h-24 ' +
                      (isSelectedCategory(filter)
                        ? 'p-button-secondary'
                        : 'p-button-text')
                    "
                    (click)="selectCategory(filter, true)"
                    [raised]="true"
                  >
                    <div class="flex flex-col">
                      <div
                        class="flex items-center justify-center"
                        style="min-height: 65px"
                      >
                        <p-image
                          class="block mx-1"
                          src="{{ filter.imgSrc }}"
                          width="37"
                          [imageStyle]="{ 'max-height': '45px' }"
                        />
                      </div>
                      <div class="flex-1">
                        <p
                          class="m-0 block font-semibold text-color-secondary font-semibold"
                        >
                          {{ filter.title }}
                        </p>
                      </div>
                    </div>
                  </p-button>
                }
              </div>
            </div>
          </div>
        </p-panel>
      }
      @if (getTabContent() === 'general') {
        <p-panel class="h-full overflow-auto p-2">
          <p-accordion [multiple]="false" value="0" class="gap-2">
            <p-accordion-panel value="0">
              <p-accordion-header>
                <span>
                  {{ 'animalAdd.general.basicData.headline' | transloco }}
                  @if (
                    formGroup.get('type')?.invalid ||
                    formGroup.get('category')?.invalid ||
                    formGroup.get('sex')?.invalid ||
                    formGroup.get('breed')?.invalid
                  ) {
                    <span
                      class="pi pi-exclamation-triangle text-red-400"
                      [pTooltip]="
                        'animalAdd.general.invalidTooltip' | transloco
                      "
                      tooltipPosition="right"
                    ></span>
                  }
                </span>
              </p-accordion-header>

              <p-accordion-content>
                <div class="grid grid-cols-2 gap-2">
                  <!-- category (required) -->
                  <div>
                    <p-iftalabel>
                      <p-select
                        class="p-inputdropdown-sm w-full"
                        id="animalCategory"
                        [options]="animalCategoryOptions"
                        optionLabel="name"
                        optionValue="value"
                        formControlName="category"
                        (onChange)="onCategoryChange($event)"
                        appendTo="body"
                        [required]="true"
                      >
                      </p-select>
                      <label for="animalCategory">
                        {{ 'animalAdd.general.basicData.category' | transloco }}
                        <span class="required text-red-400">*</span>
                      </label>
                    </p-iftalabel>
                  </div>

                  <!-- type (required) -->
                  <div>
                    <p-iftalabel>
                      <p-select
                        class="p-inputdropdown-sm w-full"
                        id="animalType"
                        [ngClass]="{
                          'p-disabled': animalTypeOptions.length === 1,
                        }"
                        [options]="animalTypeOptions"
                        optionLabel="name"
                        optionValue="value"
                        formControlName="type"
                        appendTo="body"
                        [required]="true"
                      >
                      </p-select>
                      <label for="animalType">
                        {{ 'animalAdd.general.basicData.type' | transloco }}
                        <span class="required text-red-400">*</span>
                      </label>
                    </p-iftalabel>
                  </div>

                  <!-- breed (required) -->
                  <div class="col-span-2">
                    <p-iftalabel>
                      <input
                        type="text"
                        pInputText
                        id="breed"
                        formControlName="breed"
                        class="p-inputtext-sm w-full"
                        [ngClass]="{
                          '!border-red-500': formGroup.get('breed')?.invalid,
                        }"
                        required
                      />
                      <label for="breed">
                        {{
                          'animalAdd.general.specifications.breed' | transloco
                        }}
                        <span class="required text-red-400">*</span>
                      </label>
                    </p-iftalabel>
                  </div>
                  <!-- name -->
                  <div>
                    <p-iftalabel>
                      <input
                        type="text"
                        pInputText
                        class="p-inputtext-sm w-full"
                        id="name"
                        formControlName="name"
                      />
                      <label for="name">
                        {{ 'animalAdd.general.basicData.name' | transloco }}
                      </label>
                    </p-iftalabel>
                  </div>

                  <!-- nameOld -->
                  <div>
                    <p-iftalabel>
                      <input
                        type="text"
                        pInputText
                        class="p-inputtext-sm w-full"
                        id="nameOld"
                        formControlName="nameOld"
                      />
                      <label for="nameOld">
                        {{ 'animalAdd.general.basicData.nameOld' | transloco }}
                      </label>
                    </p-iftalabel>
                  </div>

                  <!-- sex (RadioGroup) -> bleibt ohne p-iftalabel -->
                  <div>
                    <label class="field-title" for="gender">
                      {{ 'animalAdd.general.basicData.sex' | transloco }}
                      <span class="required text-red-400">*</span>
                    </label>

                    <div class="flex flex-wrap flex-row">
                      @for (genderOption of genderOptions; track genderOption) {
                        <div class="field-checkbox m-2">
                          <p-radioButton
                            [inputId]="genderOption.key"
                            [value]="genderOption.key"
                            formControlName="sex"
                            id="gender"
                            [required]="true"
                            [ngClass]="{
                              'invalid-radio': formGroup.get('sex')?.invalid,
                            }"
                          ></p-radioButton>
                          <label [for]="genderOption.key" class="ml-2">
                            {{ genderOption.name }}
                          </label>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="1">
              <p-accordion-header>
                <span>
                  {{ 'animalAdd.general.specifications.headline' | transloco }}
                </span>
              </p-accordion-header>

              <p-accordion-content>
                <div class="grid grid-cols-12 gap-2">
                  <div class="col-span-6">
                    <app-custom-date-picker
                      [label]="'animalEdit.general.specifications.birthday'"
                      [isApproximateYearInput]="true"
                      [isApproximate]="formGroup.get('birthApprox')?.value"
                      [isYearOnly]="formGroup.get('birthdayType')?.value"
                      [rawInput]="currentBirthday"
                      (valueChange)="onDelayedBirthdayChange($event)"
                      (approxChanged)="
                        formGroup.get('birthApprox')?.setValue($event)
                      "
                      (yearOnlyChanged)="onYearOnlyChanged($event)"
                    />
                  </div>

                  <!-- birthPlace -->
                  <div class="col-span-6 mt-10">
                    <p-iftalabel>
                      <input
                        type="text"
                        pInputText
                        class="p-inputtext-sm w-full"
                        id="birthPlace"
                        formControlName="birthPlace"
                      />
                      <label for="birthPlace" class="field-title">
                        {{
                          'animalAdd.general.specifications.birthPlace'
                            | transloco
                        }}
                      </label>
                    </p-iftalabel>
                  </div>
                  <div class="col-span-6">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="coatType">
                          {{
                            'animalEdit.general.specifications.coatType'
                              | transloco
                          }}
                        </label>
                        <p-multiSelect
                          id="coatType"
                          [options]="coatTypeOptions"
                          optionLabel="name"
                          optionValue="value"
                          formControlName="coatType"
                          [style]="{ width: '100%' }"
                          [panelStyle]="{ width: '100%' }"
                          appendTo="body"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>

                  <div class="col-span-6">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="coatColor">
                          {{
                            'animalEdit.general.specifications.coatColor'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="coatColor"
                          formControlName="coatColor"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-6">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="badge">
                          {{
                            'animalEdit.general.specifications.badge'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="badge"
                          formControlName="badge"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>
                  <div class="col-span-6">
                    <p-inputgroup>
                      <p-iftalabel>
                        <label for="specialNotice">
                          {{
                            'animalEdit.general.specifications.specialNotice'
                              | transloco
                          }}
                        </label>
                        <input
                          type="text"
                          pInputText
                          id="specialNotice"
                          formControlName="specialNotice"
                        />
                      </p-iftalabel>
                    </p-inputgroup>
                  </div>

                  <div class="col-span-6">
                    <p-iftalabel>
                      <p-inputgroup>
                        <input
                          type="number"
                          pInputText
                          class="p-inputtext-sm w-full"
                          id="weight"
                          [value]="weightInput"
                          (input)="onWeightInput($event)"
                          maxlength="10"
                          placeholder="z.B. 12,345"
                          autocomplete="off"
                        />
                        <p-inputgroup-addon>kg</p-inputgroup-addon>
                      </p-inputgroup>
                      <label class="field-title" for="weight">
                        {{
                          'animalAdd.general.specifications.weight' | transloco
                        }}
                      </label>
                      <small *ngIf="weightInputInvalid" class="p-error">
                        Bitte im Format 0,000 eingeben
                      </small>
                    </p-iftalabel>
                  </div>
                </div>
                <div class="col-span-12">
                  <p class="field-title mt-2">
                    {{
                      'animalDetails.general.specialInformations.specialInformation'
                        | transloco
                    }}
                  </p>
                  <app-editor-field
                    formControlName="specialInformation"
                    id="specialInformation"
                  />
                </div>
              </p-accordion-content>
            </p-accordion-panel>

            <p-accordion-panel value="2">
              <p-accordion-header>
                <span class="items-center">
                  {{ 'animalAdd.general.numbers.headline' | transloco }}
                </span>
              </p-accordion-header>

              <p-accordion-content>
                <div class="grid grid-cols-12 gap-2">
                  <div class="col-span-6">
                    <label class="field-title" for="oldBookNumber_0">
                      {{
                        'animalAdd.general.basicData.oldBookNumber' | transloco
                      }}
                    </label>
                    <p-button
                      icon="pi pi-plus"
                      class="p-button-text p-button-sm"
                      [text]="true"
                      (click)="addOldBookNumber()"
                    />
                    <div
                      formArrayName="oldBookNumberList"
                      class="flex flex-col"
                    >
                      @for (
                        ctrl of oldBookNumberControlsReversed;
                        track ctrl;
                        let i = $index
                      ) {
                        <div class="mb-1 flex items-center">
                          <p-inputgroup>
                            <input
                              pInputText
                              type="text"
                              class="p-3"
                              [formControl]="ctrl"
                              [id]="'oldBookNumber_' + i"
                              [attr.name]="'oldBookNumber_' + i"
                              spellcheck="false"
                              autocomplete="off"
                            />
                          </p-inputgroup>

                            <p-button
                              icon="pi pi-trash"
                              styleClass="ml-2 p-button-sm"
                              [rounded]="true"
                              severity="danger"
                              (click)="removeOldBookNumberControl(ctrl)"
                            />
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-span-6">
                    <label class="field-title" for="transponderNumber_0">
                      {{
                        'animalAdd.general.numbers.transponderNumber'
                          | transloco
                      }}
                    </label>
                    <p-button
                      icon="pi pi-plus"
                      class="p-button-text p-button-sm"
                      [text]="true"
                      (click)="addTransponderNumber()"
                    />
                    <div
                      formArrayName="transponderNumber"
                      class="flex flex-col"
                    >
                      @for (
                        ctrl of transponderNumbers.controls;
                        track ctrl;
                        let i = $index
                      ) {
                        <div class="mb-1 flex items-center">
                          <p-inputgroup>
                            <input
                              pInputText
                              type="text"
                              class="rounded-r-none!"
                              formControlName="{{ i }}"
                              [id]="'transponderNumber_' + i"
                              [attr.name]="'transponderNumber_' + i"
                              spellcheck="false"
                              autocomplete="off"
                              appAnimalUniqueCheck="transponderNumber"
                              (duplicateFound)="
                                onDuplicateNumber('transponderNumber', $event)
                              "
                            />
                            <app-barcode-scanner
                              [bindTo]="'transponderNumber_' + i"
                              (barcodeScanned)="
                                handleBarcodeTransponderScanned($event)
                              "
                            ></app-barcode-scanner>
                          </p-inputgroup>

                          @if (transponderNumbers.length > 1) {
                            <p-button
                              icon="pi pi-trash"
                              styleClass="ml-2 p-button-sm"
                              [rounded]="true"
                              severity="danger"
                              (click)="removeTransponderNumber(i)"
                            />
                          }
                        </div>
                      }
                    </div>
                  </div>

                  <!-- lifeNumber -->
                  <div class="col-span-6">
                    <p-iftalabel>
                      <p-inputgroup>
                        <input
                          pInputText
                          type="text"
                          id="lifeNumber"
                          formControlName="lifeNumber"
                          class="rounded-r-none!"
                          appAnimalUniqueCheck="lifeNumber"
                          (duplicateFound)="
                            onDuplicateNumber('lifeNumber', $event)
                          "
                        />
                        <app-barcode-scanner
                          [bindTo]="'lifeNumber'"
                          (barcodeScanned)="handleBarcodeScanned($event)"
                        >
                        </app-barcode-scanner>
                      </p-inputgroup>
                      <label class="field-title" for="lifeNumber">
                        {{ 'animalAdd.general.numbers.lifeNumber' | transloco }}
                      </label>
                    </p-iftalabel>
                  </div>

                  <!-- petPassportNumber -->
                  <div class="col-span-6">
                    <p-iftalabel>
                      <p-inputgroup>
                        <input
                          pInputText
                          type="text"
                          id="petPassportNumber"
                          formControlName="petPassportNumber"
                          class="rounded-r-none!"
                          appAnimalUniqueCheck="petPassportNumber"
                          (duplicateFound)="
                            onDuplicateNumber('petPassportNumber', $event)
                          "
                        />
                        <app-barcode-scanner
                          [bindTo]="'petPassportNumber'"
                          (barcodeScanned)="handleBarcodeScanned($event)"
                        >
                        </app-barcode-scanner>
                      </p-inputgroup>
                      <label class="field-title" for="petPassportNumber">
                        {{
                          'animalAdd.general.numbers.petPassportNumber'
                            | transloco
                        }}
                      </label>
                    </p-iftalabel>
                  </div>

                  <!-- equinePassportNumber -->
                  <div class="col-span-6">
                    <p-iftalabel>
                      <p-inputgroup>
                        <input
                          pInputText
                          type="text"
                          id="equinePassportNumber"
                          formControlName="equinePassportNumber"
                          class="rounded-r-none!"
                          appAnimalUniqueCheck="equinePassportNumber"
                          (duplicateFound)="
                            onDuplicateNumber('equinePassportNumber', $event)
                          "
                        />
                        <app-barcode-scanner
                          [bindTo]="'equinePassportNumber'"
                          (barcodeScanned)="handleBarcodeScanned($event)"
                        >
                        </app-barcode-scanner>
                      </p-inputgroup>
                      <label class="field-title" for="equinePassportNumber">
                        {{
                          'animalAdd.general.numbers.equinePassportNumber'
                            | transloco
                        }}
                      </label>
                    </p-iftalabel>
                  </div>

                  <!-- ringNumber -->
                  <div class="col-span-6">
                    <p-iftalabel>
                      <p-inputgroup>
                        <input
                          pInputText
                          type="text"
                          id="ringNumber"
                          formControlName="ringNumber"
                          class="rounded-r-none!"
                        />
                      </p-inputgroup>
                      <label class="field-title" for="ringNumber">
                        {{ 'animalAdd.general.numbers.ringNumber' | transloco }}
                      </label>
                    </p-iftalabel>
                  </div>

                  <!-- earTag -->
                  <div class="col-span-6">
                    <p-iftalabel>
                      <p-inputgroup>
                        <input
                          pInputText
                          type="text"
                          id="earTag"
                          formControlName="earTag"
                          class="rounded-r-none!"
                        />
                      </p-inputgroup>
                      <label class="field-title" for="earTag">
                        {{
                          'animalAdd.general.numbers.earTagNumber' | transloco
                        }}
                      </label>
                    </p-iftalabel>
                  </div>

                  <!-- tattoo -->
                  <div class="col-span-6">
                    <p-iftalabel>
                      <p-inputgroup>
                        <input
                          pInputText
                          type="text"
                          id="tattoo"
                          formControlName="tattoo"
                          class="rounded-r-none!"
                        />
                        <label class="field-title" for="tattoo">
                          {{ 'animalAdd.general.numbers.tattoo' | transloco }}
                        </label>
                      </p-inputgroup>
                    </p-iftalabel>
                  </div>

                  <!-- tattooLocation -->
                  <div class="col-span-6">
                    <p-iftalabel>
                      <input
                        type="text"
                        pInputText
                        id="tattooLocation"
                        formControlName="tattooLocation"
                        class="p-inputtext-sm w-full"
                      />
                      <label for="tattooLocation" class="field-title">
                        {{
                          'animalAdd.general.numbers.tattooLocation' | transloco
                        }}
                      </label>
                    </p-iftalabel>
                  </div>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </p-panel>
      }
      @if (getTabContent() === 'reasonForDelivery') {
        <p-panel class="h-full m-1 w-[300px] mx-auto border-none">
          <div
            class="flex w-full h-full flex-col items-stretch justify-center gap-2"
          >
            <p-button
              [raised]="true"
              [styleClass]="
                'w-full ' +
                (reasonGivenSet === reasonsForTransfer.DELIVERY
                  ? ''
                  : 'p-button-outlined')
              "
              (click)="reasonGiven(reasonsForTransfer.DELIVERY)"
              label="{{
                'animalAdd.origin.reasonForTransferSelect.delivery' | transloco
              }}"
            />
            <p-button
              [raised]="true"
              [styleClass]="
                'w-full ' +
                (reasonGivenSet === reasonsForTransfer.FOUND_ANIMAL
                  ? ''
                  : 'p-button-outlined')
              "
              (click)="reasonGiven(reasonsForTransfer.FOUND_ANIMAL)"
              label="{{
                'animalAdd.origin.reasonForTransferSelect.found_animal'
                  | transloco
              }}"
            />
            <p-button
              [raised]="true"
              [styleClass]="
                'w-full ' +
                (reasonGivenSet === reasonsForTransfer.WILD_FOUND
                  ? ''
                  : 'p-button-outlined')
              "
              (click)="reasonGiven(reasonsForTransfer.WILD_FOUND)"
              label="{{
                'animalAdd.origin.reasonForTransferSelect.wild_found'
                  | transloco
              }}"
            />
            <p-button
              [raised]="true"
              [styleClass]="
                'w-full ' +
                (reasonGivenSet ===
                reasonsForTransfer.TAKEOVER_FROM_ANOTHER_SHELTER
                  ? ''
                  : 'p-button-outlined')
              "
              (click)="
                reasonGiven(reasonsForTransfer.TAKEOVER_FROM_ANOTHER_SHELTER)
              "
              label="{{
                'animalAdd.origin.reasonForTransferSelect.takeover_from_another_shelter'
                  | transloco
              }}"
            />
            <p-button
              [raised]="true"
              [styleClass]="
                'w-full ' +
                (reasonGivenSet === reasonsForTransfer.TAKE_AWAY
                  ? ''
                  : 'p-button-outlined')
              "
              (click)="reasonGiven(reasonsForTransfer.TAKE_AWAY)"
              label="{{
                'animalAdd.origin.reasonForTransferSelect.take_away' | transloco
              }}"
            />
            <p-button
              [raised]="true"
              [styleClass]="
                'w-full ' +
                (reasonGivenSet === reasonsForTransfer.SECURED_BY_POLICE
                  ? ''
                  : 'p-button-outlined')
              "
              (click)="reasonGiven(reasonsForTransfer.SECURED_BY_POLICE)"
              label="{{
                'animalAdd.origin.reasonForTransferSelect.secured_by_police'
                  | transloco
              }}"
            />
            @if (!resumeAnimalSteps) {
              <p-button
                [raised]="true"
                [styleClass]="
                  'w-full ' +
                  (reasonGivenSet === reasonsForTransfer.BORN_IN_SHELTER
                    ? ''
                    : 'p-button-outlined')
                "
                (click)="reasonGiven(reasonsForTransfer.BORN_IN_SHELTER)"
                label="{{
                  'animalAdd.origin.reasonForTransferSelect.born_in_shelter'
                    | transloco
                }}"
              />
            }
            @if (resumeAnimalSteps) {
              <p-button
                [raised]="true"
                [styleClass]="
                  'w-full ' +
                  (reasonGivenSet === reasonsForTransfer.RESUMPTION_AFTER_TRIAL
                    ? ''
                    : 'p-button-outlined')
                "
                (click)="reasonGiven(reasonsForTransfer.RESUMPTION_AFTER_TRIAL)"
                label="{{
                  'animalAdd.origin.reasonForTransferSelect.resumption_after_trial'
                    | transloco
                }}"
              />
            }
          </div>
        </p-panel>
      }
      @if (getTabContent() === 'origin') {
        <p-panel class="h-full">
          <div class="flex flex-row">
            <div class="flex-1">
              @if (reasonGivenSet === reasonsForTransfer.FOUND_ANIMAL) {
                <p-accordion [multiple]="false" value="0" class="gap-2">
                  <p-accordion-panel value="0">
                    <p-accordion-header>
                      <span class="items-center">
                        {{ 'animalAdd.general.basicData.headline' | transloco }}
                        @if (
                          formGroup.get('foundDateTime')?.invalid ||
                          formGroup.get('originCompetentAuthority')?.invalid ||
                          formGroup.get('originLocation')?.invalid
                        ) {
                          <span
                            class="pi pi-exclamation-triangle text-red-400"
                            [pTooltip]="
                              'animalAdd.general.invalidTooltip' | transloco
                            "
                            tooltipPosition="right"
                          ></span>
                        }
                      </span>
                    </p-accordion-header>

                    <p-accordion-content>
                      <div class="grid grid-cols-12 gap-2">
                        <div class="col-span-12">
                          <p-iftalabel>
                            <p-datepicker
                              formControlName="foundDateTime"
                              [showIcon]="true"
                              [iconDisplay]="'input'"
                              [showTime]="true"
                              [hourFormat]="'24'"
                              dateFormat="dd.mm.yy"
                              [styleClass]="formGroup.get('foundDateTime')?.invalid ? 'datepicker-invalid' : ''"
                              appendTo="body"
                              />

                            <label for="foundDateTime" class="field-title">
                              {{ 'animalAdd.origin.dateOfReceiptAndTime' | transloco }}
                            </label>
                          </p-iftalabel>
                        </div>
                        <!-- originLocation -->
                        <div class="col-span-6">
                          <p-iftalabel>
                            <input
                              type="text"
                              pInputText
                              class="p-inputtext-sm w-full"
                              id="location"
                              formControlName="originLocation"
                              [ngClass]="{
                                '!border-red-500':
                                  formGroup.get('originLocation')?.invalid,
                              }"
                            />
                            <label for="location" class="field-title">
                              {{ 'animalAdd.origin.location' | transloco }}
                            </label>
                          </p-iftalabel>
                        </div>

                        <!-- originCompetentAuthority -->
                        <div class="col-span-6">
                          <div class="flex gap-2 items-center">
                            <p-iftalabel class="flex-1">
                              <p-select
                                class="p-inputdropdown-sm w-full"
                                id="originCompetentAuthority"
                                [options]="originCompetentAuthorityOptions"
                                optionLabel="name"
                                optionValue="id"
                                formControlName="originCompetentAuthority"
                                [required]="true"
                                appendTo="body"
                                [ngClass]="{
                                  '!border-red-500': formGroup.get(
                                    'originCompetentAuthority'
                                  )?.invalid,
                                }"
                              ></p-select>
                              <label for="originCompetentAuthority">
                                {{
                                  'animalAdd.origin.competentAuthority'
                                    | transloco
                                }}
                                <span class="required text-red-400">*</span>
                              </label>
                            </p-iftalabel>

                            <p-button
                              icon="pi pi-plus"
                              class="h-full"
                              (click)="showCompetentAuthorityDialog = true"
                              [pTooltip]="
                                'animalAdd.origin.competentAuthorityAdd'
                                  | transloco
                              "
                              tooltipPosition="top"
                            />
                          </div>
                        </div>

                        <!-- originSpecialInformation -->
                        <div class="col-span-6 gap-2">
                          <p-iftaLabel>
                            <textarea
                              pInputText
                              class="p-inputtext-sm w-full"
                              id="originSpecialInformation"
                              formControlName="originSpecialInformation"
                              rows="10"
                            ></textarea>
                            <label
                              class="field-title"
                              for="originSpecialInformation"
                            >
                              {{
                                'animalAdd.origin.specialInformation'
                                  | transloco
                              }}
                            </label>
                          </p-iftaLabel>
                        </div>

                        <!-- originOtherComments -->
                        <div class="col-span-6">
                          <p-iftalabel>
                            <textarea
                              pInputText
                              class="p-inputtext-sm w-full"
                              id="originOtherComments"
                              formControlName="originOtherComments"
                              rows="10"
                            ></textarea>
                            <label
                              class="field-title"
                              for="originOtherComments"
                            >
                              {{ 'animalAdd.origin.otherComments' | transloco }}
                            </label>
                          </p-iftalabel>
                        </div>
                      </div>
                    </p-accordion-content>
                  </p-accordion-panel>

                  <!-- Panel 1: Fundtier-spezifische Angaben -->
                  <p-accordion-panel value="1">
                    <p-accordion-header>
                      <span class="items-center">
                        {{
                          'animalAdd.general.foundAnimal.headline' | transloco
                        }}
                        @if (finderSectionInvalid) {
                          <span
                            class="pi pi-exclamation-triangle text-red-400"
                            [pTooltip]="
                              'animalAdd.general.invalidTooltip' | transloco
                            "
                            tooltipPosition="right"
                          ></span>
                        }
                      </span>
                    </p-accordion-header>

                    <p-accordion-content>
                      <div class="grid grid-cols-12 gap-2">
                        <!-- Foundtier-Übernahme (Option 1 & 2) -->
                        <div class="col-span-12 mt-4">
                          <div class="flex flex-col gap-3">
                            <!-- OPTION: shelter -->
                            <div class="flex items-start gap-2">
                              <p-radioButton
                                name="foundStatus"
                                inputId="foundStatus_shelter"
                                [value]="FoundStatus.SHELTER"
                                formControlName="foundStatus"
                                [ngClass]="{
                                  'invalid-radio':
                                    formGroup.get('foundStatus')?.invalid,
                                }"
                              ></p-radioButton>

                              <label
                                for="foundStatus_shelter"
                                class="cursor-pointer"
                              >
                                {{
                                  'animalAdd.general.foundAnimal.foundStatus.shelter'
                                    | transloco
                                }}
                              </label>
                            </div>

                            <!-- OPTION: collected -->
                            <div class="flex flex-col gap-2">
                              <div class="flex items-start gap-2">
                                <p-radioButton
                                  name="foundStatus"
                                  inputId="foundStatus_collected"
                                  [value]="FoundStatus.COLLECTED"
                                  formControlName="foundStatus"
                                  [ngClass]="{
                                    'invalid-radio':
                                      formGroup.get('foundStatus')?.invalid,
                                  }"
                                ></p-radioButton>

                                <label
                                  for="foundStatus_collected"
                                  class="cursor-pointer"
                                >
                                  {{
                                    'animalAdd.general.foundAnimal.foundStatus.collected.prefix'
                                      | transloco
                                  }}
                                  @if (formGroup.get('pickUpDateTime')?.value) {
                                    <strong>
                                      {{
                                        'animalAdd.general.foundAnimal.foundStatus.collected.at'
                                          | transloco
                                      }}
                                      {{
                                        formatpickUpDateTime(
                                          formGroup.get('pickUpDateTime')?.value
                                        )
                                      }}
                                      {{
                                        'animalAdd.general.foundAnimal.foundStatus.collected.oclock'
                                          | transloco
                                      }}
                                    </strong>
                                  } @else {
                                    {{
                                      'animalAdd.general.foundAnimal.foundStatus.collected.timePlaceholder'
                                        | transloco
                                    }}
                                  }
                                  {{
                                    'animalAdd.general.foundAnimal.foundStatus.collected.by'
                                      | transloco
                                  }}
                                  @if (formGroup.get('pickupUserName')?.value) {
                                    <strong>{{
                                      formGroup.get('pickupUserName')?.value
                                    }}</strong>
                                  } @else {
                                    {{
                                      'animalAdd.general.foundAnimal.foundStatus.collected.namePlaceholder'
                                        | transloco
                                    }}
                                  }
                                  {{
                                    'animalAdd.general.foundAnimal.foundStatus.collected.suffix'
                                      | transloco
                                  }}
                                </label>
                              </div>

                              @if (
                                formGroup.get('foundStatus')?.value ===
                                FoundStatus.COLLECTED
                              ) {
                                <div class="ml-7 grid grid-cols-12 gap-3">
                                  <!-- date + time -->
                                  <div class="col-span-5">
                                    <p-iftalabel>
                                      <p-datepicker
                                        formControlName="pickUpDateTime"
                                        [showTime]="true"
                                        [hourFormat]="'24'"
                                        dateFormat="dd.mm.yy"
                                        [showIcon]="true"
                                        [iconDisplay]="'input'"
                                        inputId="pickUpDateTime"
                                        inputStyleClass="p-inputtext"
                                        [styleClass]="formGroup.get('pickUpDateTime')?.invalid ? 'datepicker-invalid' : ''"
                                        appendTo="body"
                                      />
                                      <label for="pickUpDateTime">
                                        {{
                                          'animalAdd.general.foundAnimal.foundStatus.collected.timeLabel'
                                            | transloco
                                        }}
                                      </label>
                                    </p-iftalabel>
                                  </div>

                                  <!-- name -->
                                  <div class="col-span-7">
                                    <p-iftalabel>
                                      <input
                                        pInputText
                                        formControlName="pickupUserName"
                                        type="text"
                                        class="p-inputtext-sm w-full"
                                        [ngClass]="{
                                          '!border-red-500':
                                            formGroup.get('pickupUserName')
                                              ?.invalid,
                                        }"
                                      />
                                      <label for="pickupUserName">
                                        {{
                                          'animalAdd.general.foundAnimal.foundStatus.collected.nameLabel'
                                            | transloco
                                        }}
                                      </label>
                                    </p-iftalabel>
                                  </div>
                                </div>
                              }
                            </div>

                            <!-- OPTION: stays_with_finder -->
                            <div class="flex items-start gap-2">
                              <p-radioButton
                                name="foundStatus"
                                inputId="foundStatus_stays_with_finder"
                                [value]="FoundStatus.STAYS_WITH_FINDER"
                                formControlName="foundStatus"
                                [ngClass]="{
                                  'invalid-radio':
                                    formGroup.get('foundStatus')?.invalid,
                                }"
                              ></p-radioButton>

                              <label
                                for="foundStatus_stays_with_finder"
                                class="cursor-pointer"
                              >
                                {{
                                  'animalAdd.general.foundAnimal.foundStatus.staysWithFinder'
                                    | transloco
                                }}
                              </label>
                            </div>
                          </div>
                        </div>

                        <!-- Body Condition Score -->
                        <div class="col-span-12 mt-2">
                          <app-body-condition-score
                            [careCtrl]="formGroup.get('careCondition')!"
                            [nutritionCtrl]="formGroup.get('bcsNutrition')!"
                            [temperamentCtrl]="formGroup.get('temperament')!"
                          ></app-body-condition-score>
                        </div>
                      </div>
                    </p-accordion-content>
                  </p-accordion-panel>

                  <!-- Panel 2: Finder Angaben -->
                  <p-accordion-panel value="2">
                    <p-accordion-header>
                      <span class="items-center">
                        {{ 'animalAdd.origin.contacts.headline' | transloco }}
                        @if (isOriginContactsInvalidForReason) {
                          <span
                            class="pi pi-exclamation-triangle text-red-400"
                            [pTooltip]="
                              'animalAdd.general.invalidTooltip' | transloco
                            "
                            tooltipPosition="right"
                          ></span>
                        }
                      </span>
                    </p-accordion-header>

                    <p-accordion-content>
                      <div class="grid grid-cols-12 gap-2">
                        <div class="col-span-12 mt-4">
                          <div class="flex flex-col gap-3">
                            <div class="flex items-start gap-2">
                              <p-checkbox
                                inputId="consentToShareWithOwner"
                                binary="true"
                                formControlName="consentToShareWithOwner"
                              ></p-checkbox>
                              <label for="consentToShareWithOwner" class="ml-2">
                                Der Findende ist damit einverstanden, dass die
                                Daten an den Tierbesitzer weitergegeben werden.
                              </label>
                            </div>
                          </div>
                        </div>

                        <!-- DYNAMISCHE CONTACTS LISTE -->
                        <div class="col-span-12">
                          <app-origin-contacts
                            [contacts]="originContacts"
                            [typeOptions]="originContactTypeOptions"
                            [multiple]="false"
                            [activePanel]="activeOriginContactPanelIndex"
                            [showEmptyState]="false"
                            (activePanelChange)="activeOriginContactPanelIndex = $event"
                            (add)="addOriginContact()"
                            (remove)="removeOriginContact($event)"
                            (typeChanged)="onOriginContactTypeChanged($event.index, $event.type)"
                            (labelChanged)="onOriginContactLabelChanged($event.index, $event.label)"
                            (validationChanged)="onOriginValidationChanged($event.index, $event.valid)"
                            (newContactUpdated)="onOriginNewContactUpdated($event.index, $event.contact)"
                            (existingSelected)="onOriginExistingSelected($event.index, $event.contact)"
                          ></app-origin-contacts>
                        </div>
                      </div>
                    </p-accordion-content>
                  </p-accordion-panel>
                </p-accordion>
              } @else {
                <!-- ALLE ANDEREN GRÜNDE (NICHT FUND­TIER) -->
                <p-accordion [multiple]="false" value="0" class="gap-2">
                  <!-- ORIGIN: panel 1 -->
                  <p-accordion-panel value="0">
                    <p-accordion-header>
                      <span class="items-center">
                        {{ 'animalAdd.general.basicData.headline' | transloco }}
                        @if (formGroup.get('dateOfReceipt')?.invalid) {
                          <span
                            class="pi pi-exclamation-triangle text-red-400"
                            [pTooltip]="
                              'animalAdd.general.invalidTooltip' | transloco
                            "
                            tooltipPosition="right"
                          ></span>
                        }
                      </span>
                    </p-accordion-header>

                    <p-accordion-content>
                      <div class="grid grid-cols-12 gap-2">
                        <!-- dateOfReceipt -->
                        <div class="col-span-4">
                          <app-custom-date-picker
                            [label]="'animalAdd.origin.dateOfReceipt'"
                            [rawInput]="
                              formGroup.get('dateOfReceipt')?.value
                            "
                            (valueChange)="
                              formGroup
                                .get('dateOfReceipt')
                                ?.setValue($event)
                            "
                            [required]="true"
                            [inputValid]="
                              formGroup.get('dateOfReceipt')?.valid
                            "
                          />
                        </div>

                        <!-- Body Condition Score -->
                        <div class="col-span-12 mt-2">
                          <app-body-condition-score
                            [careCtrl]="originBcsCareCtrl"
                            [nutritionCtrl]="originBcsNutritionCtrl"
                            [temperamentCtrl]="originBcsTemperamentCtrl"
                          />
                        </div>

                        <!-- originSpecialInformation -->
                        <div class="col-span-6 gap-2">
                          <p-iftaLabel>
                            <textarea
                              pInputText
                              class="p-inputtext-sm w-full"
                              id="originSpecialInformation"
                              formControlName="originSpecialInformation"
                              rows="10"
                            ></textarea>
                            <label
                              class="field-title"
                              for="originSpecialInformation"
                            >
                              {{
                                'animalAdd.origin.specialInformation'
                                  | transloco
                              }}
                            </label>
                          </p-iftaLabel>
                        </div>

                        <!-- originOtherComments -->
                        <div class="col-span-6">
                          <p-iftalabel>
                            <textarea
                              pInputText
                              class="p-inputtext-sm w-full"
                              id="originOtherComments"
                              formControlName="originOtherComments"
                              rows="10"
                            ></textarea>
                            <label
                              class="field-title"
                              for="originOtherComments"
                            >
                              {{ 'animalAdd.origin.otherComments' | transloco }}
                            </label>
                          </p-iftalabel>
                        </div>
                      </div>
                    </p-accordion-content>
                  </p-accordion-panel>

                  <!-- DELIVERY / RESUMPTION -->
                  @if (
                    reasonGivenSet === reasonsForTransfer.DELIVERY ||
                    reasonGivenSet === reasonsForTransfer.RESUMPTION_AFTER_TRIAL
                  ) {
                    <p-accordion-panel value="1">
                      <p-accordion-header>
                        <span class="items-center">
                          @if (reasonGivenSet === reasonsForTransfer.DELIVERY) {
                            {{
                              'animalAdd.general.delivery.headline' | transloco
                            }}
                          }
                          @if (
                            reasonGivenSet ===
                            reasonsForTransfer.RESUMPTION_AFTER_TRIAL
                          ) {
                            {{
                              'animalAdd.general.resumption.headline'
                                | transloco
                            }}
                          }
                          @if (
                            (isOriginContactsInvalidForReason)
                          ) {
                            <span
                              class="pi pi-exclamation-triangle text-red-400"
                              [pTooltip]="
                                'animalAdd.general.invalidTooltip' | transloco
                              "
                              tooltipPosition="right"
                            ></span>
                          }
                        </span>
                      </p-accordion-header>

                      <p-accordion-content>
                        <app-origin-contacts
                          [contacts]="originContacts"
                          [typeOptions]="originContactTypeOptions"
                          [headline]="'animalAdd.origin.contacts.headline' | transloco: { default: 'Kontakte' }"
                          (add)="addOriginContact()"
                          (remove)="removeOriginContact($event)"
                          (typeChanged)="onOriginContactTypeChanged($event.index, $event.type)"
                          (labelChanged)="onOriginContactLabelChanged($event.index, $event.label)"
                          (validationChanged)="onOriginValidationChanged($event.index, $event.valid)"
                          (newContactUpdated)="onOriginNewContactUpdated($event.index, $event.contact)"
                          (existingSelected)="onOriginExistingSelected($event.index, $event.contact)"
                        ></app-origin-contacts>
                      </p-accordion-content>
                    </p-accordion-panel>
                  }

                  <!-- TAKEOVER_FROM_ANOTHER_SHELTER -->
                  @if (
                    reasonGivenSet ===
                    reasonsForTransfer.TAKEOVER_FROM_ANOTHER_SHELTER
                  ) {
                    <p-accordion-panel value="1">
                      <p-accordion-header>
                        <span class="items-center">
                          {{
                            'animalAdd.general.anotherShelter.headline'
                              | transloco
                          }}
                          @if (
                            isOriginContactsInvalidForReason
                          ) {
                            <span
                              class="pi pi-exclamation-triangle text-red-400"
                              [pTooltip]="
                                'animalAdd.general.invalidTooltip' | transloco
                              "
                              tooltipPosition="right"
                            ></span>
                          }
                        </span>
                      </p-accordion-header>

                      <p-accordion-content>
                        <div class="grid">
                          <app-origin-contacts
                            [contacts]="originContacts"
                            [typeOptions]="originContactTypeOptions"
                            [headline]="'animalAdd.origin.contacts.headline' | transloco: { default: 'Kontakte' }"
                            [showPrimaryBadge]="true"
                            (add)="addOriginContact()"
                            (remove)="removeOriginContact($event)"
                            (typeChanged)="onOriginContactTypeChanged($event.index, $event.type)"
                            (labelChanged)="onOriginContactLabelChanged($event.index, $event.label)"
                            (validationChanged)="onOriginValidationChanged($event.index, $event.valid)"
                            (newContactUpdated)="onOriginNewContactUpdated($event.index, $event.contact)"
                            (existingSelected)="onOriginExistingSelected($event.index, $event.contact)"
                          ></app-origin-contacts>
                        </div>
                      </p-accordion-content>
                    </p-accordion-panel>
                  }

                  <!-- TAKE_AWAY / WILD_FOUND -->
                  @if (
                    reasonGivenSet === reasonsForTransfer.TAKE_AWAY ||
                    reasonGivenSet === reasonsForTransfer.WILD_FOUND
                  ) {
                    <p-accordion-panel value="1">
                      <p-accordion-header>
                        <span class="items-center">
                          @if (
                            reasonGivenSet === reasonsForTransfer.TAKE_AWAY
                          ) {
                            {{
                              'animalAdd.general.takeAway.headline' | transloco
                            }}
                          }
                          @if (
                            reasonGivenSet === reasonsForTransfer.WILD_FOUND
                          ) {
                            {{
                              'animalAdd.general.wildFound.headline' | transloco
                            }}
                          }
                          @if (
                            formGroup.get('originCompetentAuthority')
                              ?.invalid ||
                            (isOriginContactsInvalidForReason)
                          ) {
                            <span
                              class="pi pi-exclamation-triangle text-red-400"
                              [pTooltip]="
                                'animalAdd.general.invalidTooltip' | transloco
                              "
                              tooltipPosition="right"
                            ></span>
                          }
                        </span>
                      </p-accordion-header>

                      <p-accordion-content>
                        <div class="grid grid-cols-12 gap-2">
                          <!-- originLocation -->
                          <div class="col-span-6">
                            <p-iftalabel>
                              <input
                                type="text"
                                pInputText
                                class="p-inputtext-sm w-full"
                                id="location"
                                formControlName="originLocation"
                              />
                              <label for="location" class="field-title">
                                {{ 'animalAdd.origin.location' | transloco }}
                              </label>
                            </p-iftalabel>
                          </div>

                          <!-- originCompetentAuthority -->
                          <div class="col-span-6">
                            <div class="flex gap-2 items-center">
                              <p-iftalabel class="flex-1">
                                <p-select
                                  class="p-inputdropdown-sm w-full"
                                  id="originCompetentAuthority"
                                  [options]="originCompetentAuthorityOptions"
                                  optionLabel="name"
                                  optionValue="id"
                                  formControlName="originCompetentAuthority"
                                  [required]="true"
                                  appendTo="body"
                                  [ngClass]="{
                                    '!border-red-500': formGroup.get(
                                      'originCompetentAuthority'
                                    )?.invalid,
                                  }"
                                ></p-select>
                                <label for="originCompetentAuthority">
                                  {{
                                    'animalAdd.origin.competentAuthority'
                                      | transloco
                                  }}
                                  <span class="required text-red-400">*</span>
                                </label>
                              </p-iftalabel>

                              <p-button
                                icon="pi pi-plus"
                                class="h-full"
                                (click)="showCompetentAuthorityDialog = true"
                                [pTooltip]="
                                  'animalAdd.origin.competentAuthorityAdd'
                                    | transloco
                                "
                                tooltipPosition="top"
                              />
                            </div>
                          </div>

                          <!-- Kontakte (Giver/Owner) -->
                          <div class="col-span-12">
                            <app-origin-contacts
                              [contacts]="originContacts"
                              [typeOptions]="originContactTypeOptions"
                              [headline]="'animalAdd.origin.contacts.headline' | transloco: { default: 'Kontakte' }"
                              (add)="addOriginContact()"
                              (remove)="removeOriginContact($event)"
                              (typeChanged)="onOriginContactTypeChanged($event.index, $event.type)"
                              (labelChanged)="onOriginContactLabelChanged($event.index, $event.label)"
                              (validationChanged)="onOriginValidationChanged($event.index, $event.valid)"
                              (newContactUpdated)="onOriginNewContactUpdated($event.index, $event.contact)"
                              (existingSelected)="onOriginExistingSelected($event.index, $event.contact)"
                            ></app-origin-contacts>
                          </div>
                        </div>
                      </p-accordion-content>
                    </p-accordion-panel>
                  }

                  <!-- BORN_IN_SHELTER -->
                  @if (reasonGivenSet === reasonsForTransfer.BORN_IN_SHELTER) {
                    <p-accordion-panel value="1">
                      <p-accordion-header>
                        <span class="items-center">
                          {{
                            'animalAdd.general.bornInShelter.headline'
                              | transloco
                          }}
                          @if (formGroup.get('motherId')?.invalid) {
                            <span
                              class="pi pi-exclamation-triangle text-red-400"
                              [pTooltip]="
                                'animalAdd.general.invalidTooltip' | transloco
                              "
                              tooltipPosition="right"
                            ></span>
                          }
                        </span>
                      </p-accordion-header>

                      <p-accordion-content>
                        <div class="grid">
                          <div class="col-span-12">
                            <app-mother-select
                              [mother]="selectedMother"
                              [excludeAnimalId]="resumeAnimal.id"
                              (motherSelected)="addMotherAnimal($event)"
                            ></app-mother-select>
                          </div>
                        </div>
                      </p-accordion-content>
                    </p-accordion-panel>
                  }
                </p-accordion>
              }
            </div>
          </div>
        </p-panel>
      }
      @if (getTabContent() === 'securing') {
        <p-panel class="h-full overflow-auto p-2">
          <app-secured-by-police
            [form]="formGroup"
            [competentAuthorities]="originCompetentAuthorityOptions"
          >
            <app-origin-contacts
              [contacts]="originContacts"
              [typeOptions]="originContactTypeOptions"
              [multiple]="false"
              [activePanel]="activeOriginContactPanelIndex"
              [showEmptyState]="false"
              (activePanelChange)="activeOriginContactPanelIndex = $event"
              (add)="addOriginContact()"
              (remove)="removeOriginContact($event)"
              (typeChanged)="onOriginContactTypeChanged($event.index, $event.type)"
              (labelChanged)="onOriginContactLabelChanged($event.index, $event.label)"
              (validationChanged)="onOriginValidationChanged($event.index, $event.valid)"
              (newContactUpdated)="onOriginNewContactUpdated($event.index, $event.contact)"
              (existingSelected)="onOriginExistingSelected($event.index, $event.contact)"
            ></app-origin-contacts>
          </app-secured-by-police>
        </p-panel>
      }
      @if (getTabContent() === 'pdf') {
        <div class="flex justify-center">
          <div class="w-full xl:w-1/2">
            <app-pdf-viewer
              [pdf]="reportPreviewBlob"
              mode="preview"
              height="calc(90vh - 280px)"
            ></app-pdf-viewer>
          </div>
        </div>
      }
      @if (getTabContent() === 'signatures') {
        <div class="grid grid-cols-12 gap-4 p-2">
          @if (securedByPoliceMode) {
            <div class="col-span-12 md:col-span-6">
              <h4 class="mb-2">
                {{ 'animalAdd.securing.signature.handoverParty' | transloco }}
              </h4>
              <app-signature-pad
                (signatureSaved)="formGroup.get('handoverPartySignature')?.setValue($event)"
                (signatureCleared)="formGroup.get('handoverPartySignature')?.setValue(null)"
              ></app-signature-pad>
            </div>

            <div class="col-span-12 md:col-span-6">
              <h4 class="mb-2">
                {{ 'animalAdd.securing.signature.employee' | transloco }}
              </h4>
              <app-signature-pad
                (signatureSaved)="formGroup.get('employeeSignature')?.setValue($event)"
                (signatureCleared)="formGroup.get('employeeSignature')?.setValue(null)"
              ></app-signature-pad>
            </div>

            <div class="col-span-12">
              <p-iftalabel>
                <p-multiSelect
                  id="presentShelterStaff"
                  [options]="presentShelterStaffOptions"
                  optionLabel="displayName"
                  optionValue="id"
                  formControlName="presentShelterStaff"
                  [filter]="true"
                  [style]="{ width: '100%' }"
                  [panelStyle]="{ width: '100%' }"
                  appendTo="body"
                />
                <label>
                  {{ 'animalAdd.securing.signature.presentShelterStaff' | transloco }}
                </label>
              </p-iftalabel>
            </div>
          } @else {
            <div class="col-span-12 md:col-span-6">
              <h4 class="mb-2">
                {{ 'animalAdd.general.foundAnimal.signature.finder' | transloco }}
              </h4>
              <app-signature-pad
                (signatureSaved)="formGroup.get('finderSignature')?.setValue($event)"
                (signatureCleared)="formGroup.get('finderSignature')?.setValue(null)"
              ></app-signature-pad>
            </div>

            <div class="col-span-12 md:col-span-6">
              <h4 class="mb-2">
                {{ 'animalAdd.general.foundAnimal.signature.employee' | transloco }}
              </h4>
              <app-signature-pad
                (signatureSaved)="formGroup.get('employeeSignature')?.setValue($event)"
                (signatureCleared)="formGroup.get('employeeSignature')?.setValue(null)"
              ></app-signature-pad>
            </div>
          }

          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <input
                pInputText
                formControlName="signatureLocation"
                class="w-full"
                [ngClass]="{
                  '!border-red-500': formGroup.get('signatureLocation')?.invalid,
                }"
              />
              <label>
                {{ 'animalAdd.general.foundAnimal.signature.location' | transloco }}
              </label>
            </p-iftalabel>
          </div>

          <div class="col-span-12 md:col-span-6">
            <p-iftalabel>
              <p-datepicker
                formControlName="signatureDate"
                [showIcon]="true"
                [iconDisplay]="'input'"
                dateFormat="dd.mm.yy"
                [styleClass]="formGroup.get('signatureDate')?.invalid ? 'datepicker-invalid' : ''"
                appendTo="body"
              />
              <label>
                {{ 'animalAdd.general.foundAnimal.signature.date' | transloco }}
              </label>
            </p-iftalabel>
          </div>
        </div>
      }
    </form>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex flex-1 items-center justify-end gap-2">
      <span class="required text-red-400"
        >* {{ 'animalAdd.general.required' | transloco }}</span
      >
      <p-button
        (click)="lastStep()"
        [disabled]="
          getTabContent() === 'search' || resumeDuplicateDialogVisible
        "
        data-cy="last-step-btn"
        icon="pi pi-angle-left"
        label="{{ 'animalAdd.lastStep' | transloco }}"
      />
      @if (activeTabIndex !== activeTabIndexLength) {
        <p-button
          (click)="nextStep()"
          [disabled]="isNextStepDisabled() || resumeDuplicateDialogVisible || isLoadingPreview"
          [loading]="isLoadingPreview"
          data-cy="next-step-btn"
          icon="pi pi-angle-right"
          iconPos="right"
          label="{{ 'animalAdd.nextStep' | transloco }}"
        />
      }
      @if (foundAnimalMode && getTabContent() === 'origin') {
        <p-button
          (click)="openFoundDuplicate()"
          [disabled]="isNextStepDisabled() || resumeDuplicateDialogVisible || isLoadingPreview"
          data-cy="duplicate-found-btn"
          icon="pi pi-copy"
          label="{{ 'animalDuplicate.button.duplicateAnimal' | transloco }}"
        />
      }
      @if (activeTabIndex === activeTabIndexLength) {
        <p-button
          form="addForm"
          (click)="saveChanges(false)"
          [disabled]="!getInvalidFormControls() || !securingSignaturesSaved || resumeDuplicateDialogVisible"
          data-cy="submit-btn"
          icon="pi pi-save"
          label="{{ 'modal.save' | transloco }}"
        />
        @if (!foundAnimalMode && !securedByPoliceMode) {
          <p-button
            (click)="saveChanges(true)"
            [disabled]="
              !getInvalidFormControls() || resumeDuplicateDialogVisible
            "
            data-cy="submit-btn"
            icon="pi pi-save"
            label="{{ 'modal.saveAndDuplicate' | transloco }}"
          />
        }

        @if (foundAnimalMode) {
          <p-button
            (click)="saveAndSendFoundReport()"
            [disabled]="
              !getInvalidFormControls() || resumeDuplicateDialogVisible
            "
            data-cy="submit-send-btn"
            icon="pi pi-send"
            label="Speichern & PDF senden"
          />
        }
      }
    </div>
  </ng-template>
  <app-competent-authority-create-dialog
    [(visible)]="showCompetentAuthorityDialog"
    (created)="onCompetentAuthorityCreated($event)"
  ></app-competent-authority-create-dialog>
</p-dialog>

@if (duplicateAnimalDialogVisible && duplicateOrigin && animal) {
  <app-duplicate-animals
    [animal]="animal"
    [origin]="duplicateOrigin"
    (closed)="onDuplicateClosed()"
  />
}

@if (foundDuplicateMode && foundDuplicateAnimal && foundDuplicateOrigin && foundDuplicateShared) {
  <app-duplicate-animals
    [animal]="foundDuplicateAnimal"
    [origin]="foundDuplicateOrigin"
    [foundProcessMode]="true"
    [foundShared]="foundDuplicateShared"
    (closed)="onFoundDuplicateClosed()"
  />
}

<p-dialog
  [(visible)]="resumeDuplicateDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [blockScroll]="true"
  [style]="{ width: '450px' }"
>
  <ng-template pTemplate="header">
    {{
      'animalAdd.duplicateDialog.title'
        | transloco: { default: 'Tier existiert schon' }
    }}
  </ng-template>

  <ng-template pTemplate="content">
    <p class="mb-3">
      {{
        'animalAdd.duplicateDialog.text'
          | transloco
            : {
                default:
                  'Es existiert bereits mindestens ein Tier mit dieser Nummer.',
              }
      }}
    </p>

    @if (resumeDuplicateCandidates.length > 1) {
      <div class="space-y-2 max-h-60 overflow-auto">
        @for (a of resumeDuplicateCandidates; track a.id) {
          <div
            class="flex items-center justify-between border rounded-md px-2 py-1"
          >
            <div class="text-sm">
              <div class="font-semibold">
                {{
                  a.name ||
                    ('animalAdd.duplicateDialog.noName'
                      | transloco: { default: 'Ohne Name' })
                }}
              </div>
              <div class="text-xs text-gray-500">
                ID: {{ a.id }} · {{ a.type }} ·
                {{ a.bookNumber || a.transponderNumber?.[0] || '' }}
              </div>
            </div>
            <p-button
              size="small"
              (click)="onDuplicateDialogResume(a)"
              label="{{
                'animalAdd.duplicateDialog.resume'
                  | transloco: { default: 'Wiederaufnehmen' }
              }}"
            />
          </div>
        }
      </div>
    } @else {
      <div class="border rounded-md px-2 py-1 text-sm">
        <div class="font-semibold">
          {{
            resumeDuplicateCandidates[0]?.name ||
              ('animalAdd.duplicateDialog.noName'
                | transloco: { default: 'Ohne Name' })
          }}
        </div>
        <div class="text-xs text-gray-500">
          ID: {{ resumeDuplicateCandidates[0]?.id }} ·
          {{ resumeDuplicateCandidates[0]?.type }} ·
          {{
            resumeDuplicateCandidates[0]?.bookNumber ||
              resumeDuplicateCandidates[0]?.transponderNumber?.[0] ||
              ''
          }}
        </div>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2 w-full">
      <p-button
        (click)="onDuplicateDialogCancel()"
        severity="secondary"
        label="{{
          'animalAdd.duplicateDialog.backToSearch'
            | transloco: { default: 'Zur Suche' }
        }}"
      />
      @if (resumeDuplicateCandidates.length === 1) {
        <p-button
          (click)="onDuplicateDialogResume(resumeDuplicateCandidates[0])"
          label="{{
            'animalAdd.duplicateDialog.resume'
              | transloco: { default: 'Wiederaufnehmen' }
          }}"
        />
      }
    </div>
  </ng-template>
</p-dialog>

@if (sendFoundReportDialogVisible) {
  <app-send-found-report-dialog
    [(visible)]="sendFoundReportDialogVisible"
    [animal]="animal"
    [id]="sendFoundReportOriginId"
    [availableContacts]="sendFoundReportContacts"
    (sent)="onSendFoundReportClosed()"
    (visibleChange)="onSendFoundReportClosed()"
  />
}
